export default __webpack_public_path__ + "static/media/AED 2 ucm_489136.99b065b3.jpg";